<template>
  <!-- 待发货申请售后页面 -->
  <div class="order_refund_con">
    <title-bar-back :title="'申请退款'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <div
      class="re_det_con text_left font12 font_weight400 colo055 line_height_17"
    >
      <div class="font14 font_weight500 line_height_20 con_title">温馨提醒</div>
      <template v-if="$appSource === 3">
        <div class="con_item">
          由于支付手续费在您付款成功后已由第三方支付机构即时收取，手续费约为订单金额3%~5%（具体以支付渠道规则为准），且该费用不可退还，因此当您取消订单时，退款金额将扣除这部分手续费。
        </div>
        <div class="con_item" style="margin-top: 8px;">
          谢谢您的理解。
        </div>
      </template>
      <template v-else>
        <div class="con_item">
          {{ $G("现金将按实际优惠金额退回您的AZ账户（首单券除外）") }}
        </div>
        <div class="con_item">
          2.取消订单成功后，已支付金额会在1～3个工作日自动退回原支付账号
        </div>
        <div class="con_item">3.因商品已分拣等原因可能会导致取消失败</div>
        <div class="con_item">
          {{
            $G("取消AZ第三方商家订单时，需要商家进行核对处理，可能会有时间延迟")
          }}
        </div>
        <div class="con_item">
          5.因若订单已在清关过程中，取消订单预计需要0-3小时反馈取消结果，请您耐心等待
        </div>
      </template>
    </div>
    <div class="re_reasion">
      <div
        class="order_id font12 font_weight500 colo087 line_height_24 text_left"
        @click="showSheet"
      >
        <div>
          <span class="det_det_title font_weight400">退款原因：</span>
          <span class="colo038">{{ reasion || "请选择退款原因" }}</span>
        </div>
        <img
          src="@/assets/common/icon_back_b87_24@2x.png"
          alt=""
          class="right_icon"
        />
      </div>
      <div
        class="det_item font12 font_weight500 colo087 line_height_17 text_left"
      >
        <span class="det_det_title font_weight400">下单时间：</span
        >{{ $route.query.gmtCreate | dateFormatterJava("YYYY-MM-DD HH:mm:ss") }}
      </div>
      <div
        class="det_item font12 font_weight500 colo087 line_height_17 text_left"
      >
        <span class="det_det_title font_weight400">退款方式：</span>按照原路返还
      </div>
      <div
        class="det_item font12 font_weight500 colo087 line_height_17 text_left"
      >
        <span class="det_det_title font_weight400">退款联系人：</span
        >{{ getContactor.username }}
      </div>
      <div
        class="det_item font12 font_weight500 colo087 line_height_17 text_left"
      >
        <span class="det_det_title font_weight400">联系方式：</span
        >{{ getContactor.phone }}
      </div>
    </div>
    <div class="bottom_btn line_height_30">
      <div class="btn_cancel font12 font_weight500 colo0" @click="back">
        取消
      </div>
      <div
        class="btn_confirm font12 font_weight500 colof"
        @click="confirmReasion"
      >
        确认
      </div>
    </div>
    <!-- 原因弹窗 -->
    <reasion-action-sheet
      v-if="showReasion"
      @closeSheet="closeSheet"
      @sure="sure"
    />
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
const ReasionActionSheet = () =>
  import("./components/ReasionActionSheet").then(m => m.default || m);
export default {
  name: "OrderDetailrefRundReasion",
  components: {
    TitleBarBack,
    ReasionActionSheet
  },
  data() {
    return {
      showReasion: false,
      reasion: ""
    };
  },
  computed: {
    getContactor() {
      return this.$store.getters.getContactor;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    // 取消接口
    cancelData(refundReason) {
      this.$store
        .dispatch("order/cancelOrder", {
          params: {
            orderSn: this.$route.query.orderSn,
            refundReason
          }
        })
        .then(() => {
          this.$router.go(-1);
          this.showReasion = false;
        })
        .catch(() => {});
    },
    // 申请退款信息getContactor
    getData() {
      this.$store
        .dispatch("order/getContactor", {
          params: {
            orderSn: this.$route.query.orderSn
          }
        })
        .then(() => {})
        .catch(() => {});
    },
    back() {
      this.$router.back();
    },
    showSheet() {
      this.showReasion = true;
    },
    closeSheet() {
      this.showReasion = false;
    },
    sure(reasion) {
      this.reasion = reasion;
      this.showReasion = false;
    },
    confirmReasion() {
      this.cancelData(this.reasion);
    }
  }
};
</script>

<style lang="less" scoped>
.order_refund_con {
  // background: #fff;
  .title_right {
    width: 36px;
  }
  .re_det_con {
    margin-top: 12px;
    background: #fff;
    padding: 10px 16px 16px;
    .con_title {
      margin-bottom: 16px;
    }
  }
  .re_reasion {
    margin-top: 12px;
    background: #fff;
    padding: 12px 12px 4px;
    .order_id {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding-bottom: 12px;
      vertical-align: middle;
      .right_icon {
        width: 24px;
        vertical-align: middle;
      }
    }
    .det_item {
      padding-bottom: 12px;
    }
    .det_det_title {
      width: 84px;
      display: inline-block;
    }
  }
  .bottom_btn {
    position: fixed;
    bottom: 8px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    padding: 0 4px;
    .btn_cancel {
      flex: 1;
      border-radius: 21px;
      border: 1px solid #000;
      margin: 0 12px;
      box-sizing: border-box;
    }
    .btn_confirm {
      flex: 1;
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border-radius: 16px;
      margin: 0 12px;
    }
  }
}
</style>
